<template>
  <div id="form-recepcion">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">{{
            titleView
          }}</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-layout>
            <v-flex>
              <v-card max-width="100%" height="115">
                <v-card-text>Nivel: {{ this.nivel }}</v-card-text>
                <v-card-text
                  >Tipo De Prueba: {{ this.tipo_prueba }}</v-card-text
                >
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout v-if="tipeView == 'consulta'">
          <v-flex>
            <grid-cajas
              :tipo_prueba="tipo_prueba"
              :id_nivel="id_nivel"
              :key="recepcionGrid"
              :contratoId="contratoId"
            ></grid-cajas>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import GridCajas from "./GridCajas.vue";

export default {
  name: "FormRecepcion",
  components: {
    GridCajas,
  },
  props: {},

  data() {
    return {
      contratoId: "",
      recepcionGrid: "",
      userlogged: "",
      id_nivel: "",
    };
  },

  created() {
    this.tipo_prueba = this.$route.params.tipo_prueba;
    this.nivel = this.$route.params.nivel;
    this.id_nivel = "" + this.$route.params.id_nivel;

    this.titleView = this.$route.params.titleView;
    this.idContrato = this.$store.getters.contratoStored;

    this.tipeView = "consulta";
    this.userlogged = this.$store.getters.userLogged.tipo;
  },
  mounted() {},
  computed: {},
  methods: {
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoCaptura",
        });
      }, 1000);
    },
  },
};
</script>
